import { useState } from "react";
import { setMobileBackColor, setMobileCardColor, setMobileTextColor } from "../utility";
import { Container, Navbar } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import coverSample from "../images/No_Image_Available.jpg";
import no_image from "../images/No_Image_Available.jpg";
import axios from "axios";
import Toast from "../common/toast";
import { useQuery } from "react-query";
import "../css/mobileScreens.css";
import Loading from "../common/loading";
import DishFullRow from "../components/mobile screen/sections/dishFullRow";
import { Button } from "@mui/material";
import { ArrowBackOutlined } from "@mui/icons-material";
import no_archive from "../images/no_archive.png";
import { t } from "i18next";
import BottomNavBar from "../components/BottomNavBar";

const Favorites = ({ tableQr, tableName }) => {
	const queryString = window.location.search;
	const urlParam = new URLSearchParams(queryString);
	const [favorites, setFavorites] = useState([]);
	const [isFavLoading,setIsFavLoading]=useState(true);

	const navigate = useNavigate();
	const lang = localStorage.getItem("lang");
	const [toastSettings, setToastSettings] = useState({
		open: false,
		message: "",
		success: false,
	});

	const { data: favoritesData, isLoading: favoritesIsLoading } = useQuery(
		"favorites",
		async () => {
			const favoritesFromCookie = localStorage.getItem("favorites");
			if (favoritesFromCookie) {
				const favoritesItems = JSON.parse(favoritesFromCookie);
				const favoritesArray = favoritesItems?.map((item) => item.id);
				const promise = await axios.get(
					`${process.env.REACT_APP_API
					}/menus/${tableQr}/favourites?items=${JSON.stringify(
						favoritesArray
					)}`,
					{ headers: { localization: lang } }
				);

				setFavorites(promise?.data.data.items);
        setIsFavLoading(false);
				return promise;
			} else {
				setFavorites([]);
        setIsFavLoading(false);

				return [];
			}

		}
	);

	const handleFavorite = (item) => {

		const index = favorites.findIndex((fav) => fav.id === item.id);
		if (index === -1) {
			const newFavorites = [...favorites, item];
			setFavorites(newFavorites);
			localStorage.setItem("favorites", JSON.stringify(newFavorites));
			handleOpenToast(t("Added to favorites"));
		} else {
			const newFavorites = favorites.filter(
				(favItem) => favItem.id !== item.id
			);
			setFavorites(newFavorites);
			localStorage.setItem("favorites", JSON.stringify(newFavorites));
			handleOpenToast(t("Removed from favorites"));
		}
	};

	const handleBack = () => {
		if (urlParam.get("section")) {
		navigate(
		`/${tableName}/${tableQr}/sections?section=${urlParam.get(
		"section"
		)}&t=${urlParam.get("t")}&lang=${localStorage.getItem("lang")}`
		);
		} else {
		navigate(
		`/${tableName}/${tableQr}/sections?section=0&t=${urlParam.get("t")}&lang=${localStorage.getItem("lang")}`
		);
		}

		// navigate(-1);

	};

	const handleBackHome = () => {
		navigate(
			`/${tableName}/${tableQr}/sections?section=0&t=${urlParam.get("t")}&lang=${localStorage.getItem("lang")}`
		);
	};

	const onImageError = (e) => {
		e.target.src = coverSample;
	};

	const { data, isLoading, isFetching, isError, error } = useQuery(
		"public-details",
		async () => {
			try {
				const timeZone = localStorage.getItem("timezone") ? localStorage.getItem("timezone") : "";

				const promise = await axios.get(
					`${process.env.REACT_APP_API}/menus/${tableQr}/public-details`,
					{ headers: { localization: localStorage.getItem("lang"), timeZone } }
				);
				if (promise.status === 200) {
					if (!localStorage.getItem("showOption")) {
						localStorage.setItem(
							"showOption",
							promise.data.data.mobile_settings?.showOption
						);
					}
					if (promise.data.data.mobile_settings?.theme === "costomize") {
						localStorage.setItem(
							"theme",
							promise.data.data.mobile_settings?.theme
						);
						localStorage.setItem(
							"textColor",
							promise.data?.data.mobile_settings.colorProps.text
						);
						localStorage.setItem(
							"backColor",
							promise.data?.data.mobile_settings.colorProps.back
						);
						localStorage.setItem(
							"cardColor",
							promise.data?.data.mobile_settings.colorProps.card
						);
						localStorage.setItem(
							"highlights",
							promise.data?.data.mobile_settings.colorProps.highlights
						);
					} else {
						if (
							localStorage.getItem("theme") !== "dark" &&
							localStorage.getItem("theme") !== "light"
						) {
							localStorage.setItem(
								"theme",
								promise.data.data.mobile_settings?.theme
							);
						}
					}
				}
				return promise;
			} catch (error) { }
		}
	);

	const handleOpenToast = (message) => {
		const toast = { ...toastSettings };
		toast.open = true;
		toast.success = true;
		toast.message = message;
		setToastSettings(toast);
	};

	const handleCloseToast = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}

		setToastSettings({ open: false, message: "", success: false });
	};

	if (isLoading || favoritesIsLoading || isFavLoading) {
		return <Loading />;
	}

	return (
		<div
			className={`min-vh-100`}
			style={{ backgroundColor: setMobileBackColor() }}
		>
			<Container fluid>
				<div style={{ marginBottom: 70 }} className="row">
					<div className="col-lg-8 d-none d-lg-block">
						<div className="vh-100 mt-5 text-center d-flex-justify-content-center align-items-center">
							<div style={{ marginTop: "20%" }}>
								<img
									src={data.data.data?.logo || no_image}
									className="me-4"
									style={{ width: "250px", height: "250px" }}
									onError={onImageError}
								/>
								<h1
									className="mt-4 head-font"
									style={{ color: setMobileTextColor() }}
								>
									{data.data.data?.venu_name}
								</h1>
							</div>
						</div>
					</div>

					<div className="col-lg-4 ms-auto p-0">
						<div className="mobile-side-screen">
							<div className="slider-mobile">
								<img
									src={data?.data.data.cover || coverSample}
									onError={onImageError}
									className="slider-mobile-image"
								/>
								<Navbar
									className={`d-flex justify-content-between align-items-center mobile-top-nav`}
									style={{ backgroundColor: setMobileBackColor() }}
								>
									<Button
										variant="text"
										className={`ms-2 dark-color cursor`}
										style={{ color: setMobileTextColor() }}
										onClick={() => handleBack()}
									>
										<ArrowBackOutlined sx={{ color: setMobileTextColor() }} />
									</Button>

									<Navbar.Brand className="text-center">
										<img
											src={data?.data.data.logo || no_image}
											className="me-4 slider-mobile-logo cursor"
											onError={onImageError}
											onClick={handleBackHome}
										/>
									</Navbar.Brand>
								</Navbar>
							</div>

							<div className="sections">
								<div
									className="sections-content"
									style={{ marginTop: "64px", marginBottom: "24px" }}
								>
									{favorites?.length > 0 ? (
										favorites.map((item) => {
											return (
												<DishFullRow
													key={item.id}
													item={item}
													qrCode={tableQr}
													qrName={tableName}
													sympole={favoritesData.data?.data.currency_symbol}
													handleFavorite={handleFavorite}
													favorites={favorites}
												/>
											);
										})
									) : (
										<div
											className="no-favorite p-24"
											style={{ backgroundColor: setMobileCardColor() }}
										>
											<div>
												<img src={no_archive} alt="Not Found Image" />
											</div>
											<div className="text-center mt-5 m-auto">
												<h4
													className="head-font"
													style={{ color: setMobileTextColor() }}
												>
													{t("There are no items in the wishlist")}
												</h4>
											</div>
										</div>
									)}
								</div>
							</div>
						</div>
					</div>

					<Toast
						open={toastSettings.open}
						message={toastSettings.message}
						resetToast={handleCloseToast}
						success={toastSettings.success}
					/>
				</div>
			</Container>
			<BottomNavBar qr={tableQr} qrName={tableName} />

		</div>
	);
};

export default Favorites;
